module.exports = __webpack_public_path__ + "static/media/golfer-3-a.d65ba8cc.png";